import React, {useEffect, useRef, useState} from 'react'

import {useTranslation} from 'react-i18next'
import {Autocomplete, Box, FormControl, MenuItem, Modal, Select, TextField, Tooltip, Stack, FormControlLabel, RadioGroup, Radio} from '@mui/material'
import {MobileDatePicker} from '@mui/x-date-pickers/MobileDatePicker';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import {DemoContainer} from '@mui/x-date-pickers/internals/demo'
import {MobileTimePicker} from '@mui/x-date-pickers/MobileTimePicker'
import dayjs from 'dayjs'
import Swal from 'sweetalert2'
import {useNavigate} from "react-router-dom";
import MenuBookIcon from '@mui/icons-material/MenuBook'

import style from '../../styles/style'
import {useStateContext} from '../../context/ContextProvider'
import axios from '../../lib/axios'
import TableShared from '../TableShared'
import AddButton from '../AddButton'
import AddSalesOrderItem from '../sales_purchase_orders/AddSalesOrderItem'
import AddPurchaseOrderItem from '../sales_purchase_orders/AddPurchaseOrderItem';
import { createRegexFromString, deleteZero, handleAxiosError, handleInteger, handleNumber, handleZero, isValid } from '../../helpers/helper'
import { includes, isEqual, sortBy, toNumber } from 'lodash';
import UnevenQuantitiesModal from '../broker_transactions/UnevenQuantitiesModal';
import { AUTOCOMPLETE_STYLE, MOBILE_DATE_PICKER_STYLE, MOBILE_TIME_PICKER_STYLE, SELECT_STYLE, TEXTFIELD_STYLE } from '../../constants/constants';
import clsx from 'clsx';

const CreateBrokerTransactionCustomerUser = ({
    open,
    handleOpen,
    setIsLoading,
    request = null
}) => {

    const { t } = useTranslation()
    const { company_id, config, choosesite, currencySymbol, logisticsTypes, features } = useStateContext()
    const navigate = useNavigate()

    /* state */
    const [customers, setCustomers] = useState([])
    const [vendors, setVendors] = useState([])
    const [shipToLocations, setShipToLocations] = useState([])
    const [purchaseLocations, setPurchaseLocations] = useState([])

    const initialSalesOrderItems = request?.sales_order_items || []
    const [salesOrderItems, setSalesOrderItems] = useState([])

    const initialPurchaseOrderItems = request?.purchase_order_items || []
    const [purchaseOrderItems, setPurchaseOrderItems] = useState([])

    const [openSalesOrderItem, setOpenSalesOrderItem] = useState(false)
    const [openPurchaseOrderItem, setOpenPurchaseOrderItem] = useState(false)
    const [openUnevenQuantitiesModal, setOpenUnevenQuantitiesModal] = useState(false)

    const [disabled, setDisabled] = useState(true)
    const [totalPrice, setTotalPrice] = useState(0)
    const [totalQty, setTotalQty] = useState(0)
    const [totalPricePurchase, setTotalPricePurchase] = useState(0)
    const [totalQtyPurchase, setTotalQtyPurchase] = useState(0)
    const [disabledButtonSales] = useState(false)
    const [disabledButtonPurchase, setDisabledButtonPurchase] = useState(true)

    /* form */
    const [type] = useState(request?.type || 'shipment')
    const [filteredLogisticsTypes, setFilteredLogisticsTypes] = useState([])
    const [logisticsTypeId, setLogisticsTypeId] = useState('')
    const [logisticsTypeKey, setLogisticsTypeKey] = useState('')

    const initialCustomerId = request?.type == 'shipment' ? request?.customer_id : undefined;
    const [customer, setCustomer] = useState(null)
    const [customerInputValue, setCustomerInputValue] = useState('')

    const initialVendorId = request?.vendor_id
    const [vendor, setVendor] = useState(null)
    const [vendorInputValue, setVendorInputValue] = useState('')

    const [tplVendor, setTplVendor] = useState(null)
    const [tplVendorInputValue, setTplVendorInputValue] = useState('')

    const [deliveryCost, setDeliveryCost] = useState('')

    const initialShipAddressId = request?.ship_to_location_id ?? ''
    const [shipToAddressId, setShipToAddressId] = useState(initialShipAddressId)

    const initialPurchaseAddressId = request?.purchase_location_id ?? ''
    const [purchaseAddressId, setPurchaseAddressId] = useState(initialPurchaseAddressId)

    const [address, setAddress] = useState('')
    const [zip, setZip] = useState('')
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [deliveryInstructions, setDeliveryInstructions] = useState('')
    const [addressVendor, setAddressVendor] = useState('')
    const [zipVendor, setZipVendor] = useState('')
    const [cityVendor, setCityVendor] = useState('')
    const [stateVendor, setStateVendor] = useState('')
    const [pickupInstructions, setPickupInstructions] = useState('')

    const [requestedDeliveryDate, setRequestedDeliveryDate] = useState(() => {
        const t = request?.type || 'shipment';
        if(t === 'shipment') {
            return dayjs(request?.requested_shipment_date).endOf('day');
        } else {
            return dayjs(request?.requested_collection_date).endOf('day');
        }
    })
    const [deliveryTime, setDeliveryTime] = useState('')
    const [requestedDeliveryTime, setRequestedDeliveryTime] = useState(() => {
        const t = request?.type || 'shipment';
        if(t === 'shipment') {
            return dayjs(request?.requested_shipment_date).endOf('day');
        } else {
            return dayjs(request?.requested_collection_date).endOf('day');
        }
    })
    const [pickupAppointmentTime, setPickupAppointmentTime] = useState(dayjs().endOf('minute'))
    const [shippedDate, setShippedDate] = useState(dayjs().endOf('day'))
    const [customerPoNo, setCustomerPoNo] = useState(request?.customer_po_no)
    const [pickupTrailerNo, setPickupTrailerNo] = useState(request?.pickup_trailer_no)
    const [dropTrailerNo, setDropTrailerNo] = useState('')
    const [bolNo, setBolNo] = useState(request?.broker_bol_no)
    const [comments, setComments] = useState('')
    const [requestCreatorComments] = useState(request?.comments || '')
    const [SCItems, setSCItems] = useState([])
    const [PCItems, setPCItems] = useState([])

    const [templates, setTemplates] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [prevSelectedTemplate, setPrevSelectedTemplate] = useState(null)

    /*
     * Mirrors `selectedTemplate` without being a dependency of the cascades below - see
     * CreateBrokerTransaction.jsx for the full rationale. Guards the existing address/contract-item
     * refetch effects so they don't immediately clobber fields a just-applied template set.
     */
    const templateActiveRef = useRef(false)
    useEffect(() => {
        templateActiveRef.current = Boolean(selectedTemplate)
    }, [selectedTemplate])

    /* Set while the template-fill effect is populating fields, so the item-identity
     * check doesn't compare against a stale array on the render before it catches up. */
    const justAppliedTemplateRef = useRef(false)

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.keyCode == '13') {
                if (open) createBrokerTransaction()
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [
        open,
        type,
        logisticsTypeId,
        customer,
        vendor,
        tplVendor,
        deliveryCost,
        shipToAddressId,
        purchaseAddressId,
        dropTrailerNo,
        pickupTrailerNo,
        customerPoNo,
        bolNo,
        requestedDeliveryDate,
        deliveryTime,
        requestedDeliveryTime,
        pickupAppointmentTime,
        shippedDate,
        salesOrderItems,
        purchaseOrderItems,
        comments,
        choosesite
    ])

    /* UseEffect */
    useEffect(() => {
        if (open) {
            if(isValid(company_id)) {
                getCustomers(company_id)
                getVendors(company_id)
            }
        }
    }, [open, company_id])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if(isValid(customer?.id)) {
            getShipToLocations(customer.id)
        }
    }, [customer])

    useEffect(() => {
        if(isValid(vendor?.id)) {
            setDisabledButtonPurchase(false)
        } else {
            setDisabledButtonPurchase(true)
        }
    }, [vendor])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if(isValid(vendor?.id)) {
            getPurchaseLocations(vendor.id)
        }
    }, [vendor])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if (
            shipToLocations.length > 0
            && isValid(shipToAddressId)
        ) {
            setSalesOrderItems([])

            setTimeout(() => {
                getSalesContractItems(shipToAddressId)
            }, 250)
        }
    }, [shipToLocations, shipToAddressId])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if (
            purchaseLocations.length > 0
            && isValid(purchaseAddressId)
        ) {
            setPurchaseOrderItems([])

            setTimeout(() => {
                getPurchaseContractItems(purchaseAddressId)
            }, 250)
        }
    }, [purchaseLocations, purchaseAddressId])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if (SCItems.length > 0) {
            handleNewItem(SCItems)
        }
    }, [SCItems])

    useEffect(() => {
        if(templateActiveRef.current) return;

        if (PCItems.length > 0) {
            handleNewItemPurchase(PCItems)
        }
    }, [PCItems])

    useEffect(() => {
        handleTotalPrice()
        handleTotalQty()
    }, [salesOrderItems])

    useEffect(() => {
        handleTotalPricePurchase()
        handleTotalQtyPurchase()
    }, [purchaseOrderItems])

    useEffect(() => {
        setTplVendor(null)
        setDeliveryCost('')
    }, [logisticsTypeKey])

    useEffect(() => {
        if(
            includes(['tpl'], logisticsTypeKey)
            && (dayjs(pickupAppointmentTime).isAfter(dayjs(requestedDeliveryTime)))
        ) {
            setRequestedDeliveryTime(dayjs(pickupAppointmentTime))
        }
    }, [requestedDeliveryTime, pickupAppointmentTime, logisticsTypeKey])

    useEffect(() => {
        setFilteredLogisticsTypes(logisticsTypes.filter((ltype) => ltype.availability?.includes(type)))
    }, [logisticsTypes, type])

    useEffect(() => {
        if(templateActiveRef.current) return;

        switch(type) {
            case "shipment":
                if(customer && shipToAddressId) {
                    getTemplates("shipment", { customerId: customer.id, shipAddressId: shipToAddressId })
                }
                break;
            case "collection":
                if(vendor && purchaseAddressId) {
                    getTemplates("collection", { vendorId: vendor.id, purchaseAddressId: purchaseAddressId })
                }
                break;
            default:
                console.error(`Could not retrieve templates! Reason: unsupported type (${type})`);
        }
    }, [type, customer, shipToAddressId, vendor, purchaseAddressId])

    /*
     * Template only ever fills in the side this form leaves editable for the admin - vendor/purchase
     * address for a shipment (the customer/ship-to side is locked to the customer's original request),
     * customer/ship address for a collection (the vendor/purchase side is locked). Mirrors
     * CreateBrokerTransaction.jsx's template-fill effect.
     */
    useEffect(() => {
        if(selectedTemplate) {
            justAppliedTemplateRef.current = true;

            switch(type) {
                case "shipment":
                    setVendor({
                        label: `${selectedTemplate?.vendor?.vendor_no} - ${selectedTemplate?.vendor?.name}`,
                        id: selectedTemplate?.vendor?.id
                    });
                    setVendorInputValue(`${selectedTemplate?.vendor?.vendor_no} - ${selectedTemplate?.vendor?.name}`);
                    setPurchaseAddressId(selectedTemplate?.purchase_address_id);
                    getPurchaseLocationsForTemplate(selectedTemplate?.vendor_id, selectedTemplate?.purchase_address_id);
                    setSalesOrderItems(selectedTemplate?.sales_order_items?.map((soi) => ({
                        "id": `soi_${soi.id}`,
                        "item_no": soi.item?.item_no,
                        "description": soi.item?.description,
                        "qty_ordered": soi.qty_ordered,
                        "qty_to_ship": 0,
                        "qty_shipped": 0,
                        "qty_loaded": 0,
                        "unit_price": soi.unit_price,
                        "total_cost": soi.qty_ordered * soi.unit_price,
                        "color": soi.item?.color,
                        "unit_id": soi.item?.id,
                        "unit_of_measure_code": soi.item?.unit_of_measure?.code,
                        "unit_type": soi.item?.item_type?.key
                    })))
                    setPurchaseOrderItems(selectedTemplate?.purchase_order_items?.map((poi) => ({
                        "id": `poi_${poi.id}`,
                        "item_no": poi.item?.item_no,
                        "description": poi.item?.description,
                        "qty_ordered": poi.qty_ordered,
                        "qty_to_receive": 0,
                        "qty_received": 0,
                        "qty_unloaded": 0,
                        "vendor_count": 0,
                        "unit_price": poi.unit_price,
                        "total_cost": poi.qty_ordered * poi.unit_price,
                        "color": poi.item?.color,
                        "unit_id": poi.item?.id,
                        "unit_of_measure_code": poi.item?.unit_of_measure?.code,
                        "unit_type": poi.item?.item_type?.key
                    })))
                    setDisabledButtonPurchase(false)
                    break;
                case "collection":
                    setCustomer({
                        label: `${selectedTemplate?.customer?.customer_no} - ${selectedTemplate?.customer?.name}`,
                        id: selectedTemplate?.customer?.id
                    });
                    setCustomerInputValue(`${selectedTemplate?.customer?.customer_no} - ${selectedTemplate?.customer?.name}`);
                    setShipToAddressId(selectedTemplate?.ship_address_id);
                    getShipToLocationsForTemplate(selectedTemplate?.customer_id, selectedTemplate?.ship_address_id);
                    setSalesOrderItems(selectedTemplate?.sales_order_items?.map((soi) => ({
                        "id": `soi_${soi.id}`,
                        "item_no": soi.item?.item_no,
                        "description": soi.item?.description,
                        "qty_ordered": soi.qty_ordered,
                        "qty_to_ship": 0,
                        "qty_shipped": 0,
                        "qty_loaded": 0,
                        "unit_price": soi.unit_price,
                        "total_cost": soi.qty_ordered * soi.unit_price,
                        "color": soi.item?.color,
                        "unit_id": soi.item?.id,
                        "unit_of_measure_code": soi.item?.unit_of_measure?.code,
                        "unit_type": soi.item?.item_type?.key
                    })))
                    setPurchaseOrderItems(selectedTemplate?.purchase_order_items?.map((poi) => ({
                        "id": `poi_${poi.id}`,
                        "item_no": poi.item?.item_no,
                        "description": poi.item?.description,
                        "qty_ordered": poi.qty_ordered,
                        "qty_to_receive": 0,
                        "qty_received": 0,
                        "qty_unloaded": 0,
                        "vendor_count": 0,
                        "unit_price": poi.unit_price,
                        "total_cost": poi.qty_ordered * poi.unit_price,
                        "color": poi.item?.color,
                        "unit_id": poi.item?.id,
                        "unit_of_measure_code": poi.item?.unit_of_measure?.code,
                        "unit_type": poi.item?.item_type?.key
                    })))
                    setDisabledButtonPurchase(false)
                    break;
                default:
            }
        }
    }, [type, selectedTemplate])

    /*
     * Customer/vendor/address deviation on the editable side is handled imperatively in their
     * onChange handlers (dropping the template the instant the admin picks a different value), so
     * there's no lag waiting for this effect to notice. Item identity is the one thing that can't be
     * funneled through a single handler - checked reactively here, same as CreateBrokerTransaction.jsx.
     */
    useEffect(() => {
        if(!selectedTemplate) return;

        if(justAppliedTemplateRef.current) {
            justAppliedTemplateRef.current = false;
            return;
        }

        const sameSalesItems = isEqual(
            sortBy((selectedTemplate.sales_order_items || []).map((soi) => soi.item?.id)),
            sortBy(salesOrderItems.map((item) => item.unit_id))
        );

        const samePurchaseItems = isEqual(
            sortBy((selectedTemplate.purchase_order_items || []).map((poi) => poi.item?.id)),
            sortBy(purchaseOrderItems.map((item) => item.unit_id))
        );

        if(!sameSalesItems || !samePurchaseItems) {
            setPrevSelectedTemplate(selectedTemplate);
            setSelectedTemplate(null);
        }
    }, [selectedTemplate, salesOrderItems, purchaseOrderItems])

    /* Handlers */
    const handleNewItem = (e) => {
        e.map((item) => {
            let new_item = {
                "id": item.id,
                "item_no": item.item_no,
                "description": item.description,
                "qty_ordered": item.quantity,
                "qty_to_ship": 0,
                "qty_shipped": 0,
                "qty_loaded": 0,
                "unit_price": item.unit_price,
                "total_cost": item.quantity * item.unit_price,
                "color": item.color,
                "unit_id": item.item_id,
                "unit_of_measure_code": item.unit_of_measure_code,
                "unit_type": item?.unit_type
            }

            setSalesOrderItems((prev) => [...prev, new_item])
        })
    }

    const handleNewItemPurchase = (e) => {
        e.map((item) => {
            let new_item = {
                "id": item.id,
                "item_no": item.item_no,
                "description": item.description,
                "qty_ordered": item.quantity,
                "qty_to_receive": 0,
                "qty_received": 0,
                "qty_unloaded": 0,
                "vendor_count": 0,
                "unit_price": item.unit_price,
                "total_cost": item.quantity * item.unit_price,
                "color": item.color,
                "unit_id": item.item_id,
                "unit_of_measure_code": item.unit_of_measure_code,
                "unit_type": item?.unit_type
            }

            setPurchaseOrderItems((prev) => [...prev, new_item])
        })
    }

    const handleTotalPrice = () => {
        const sum = salesOrderItems.reduce((accumulator, currentValue) => toNumber(accumulator) + toNumber(currentValue.total_cost), 0);
        setTotalPrice(sum);
    }

    const handleTotalQty = () => {
        const totalQtyToShip = salesOrderItems.reduce((sum, item) => sum + (item.qty_to_ship || 0), 0);
        const totalQtyOrdered = salesOrderItems.reduce((sum, item) => sum + (item.qty_ordered || 0), 0);

        let sum = 0;

        if(totalQtyToShip > 0) {
            sum = totalQtyToShip;
        } else if(totalQtyOrdered > 0) {
            sum = totalQtyOrdered;
        }

        setTotalQty(sum);
    }

    const handleTotalPricePurchase = () => {
        const sum = purchaseOrderItems.reduce((accumulator, currentValue) => toNumber(accumulator) + toNumber(currentValue.total_cost), 0);
        setTotalPricePurchase(sum);
    }

    const handleTotalQtyPurchase = () => {
        const totalQtyToReceive = purchaseOrderItems.reduce((sum, item) => sum + (item.qty_to_receive || 0), 0);
        const totalQtyOrdered = purchaseOrderItems.reduce((sum, item) => sum + (item.qty_ordered || 0), 0);

        let sum = 0;

        if(totalQtyToReceive > 0) {
            sum = totalQtyToReceive;
        } else if(totalQtyOrdered > 0) {
            sum = totalQtyOrdered;
        }

        setTotalQtyPurchase(sum);
    }

    const handleToggleModal = () => {
        handleOpen()
    }

    const handleCustomerPoNo = (e) => {
        const limit = 50;
        setCustomerPoNo(e.target.value.slice(0, limit));
    }

    const handleShipToLocation = (e) => {
        setPrevSelectedTemplate(selectedTemplate)
        setSelectedTemplate(null)
        setShipToAddressId(e.target.value)
        const item = shipToLocations.find(item => item.id === e.target.value)
        setAddress(item.address)
        setZip(item.zip)
        setCity(item.city)
        setState(item.state)
        setDeliveryInstructions(item?.delivery_instructions)
    }

    const handlePurchaseLocation = (e) => {
        setPrevSelectedTemplate(selectedTemplate)
        setSelectedTemplate(null)
        setPurchaseAddressId(e.target.value)
        const item = purchaseLocations.find(item => item.id === e.target.value)
        setAddressVendor(item.address)
        setZipVendor(item.zip)
        setCityVendor(item.city)
        setStateVendor(item.state)
        setPickupInstructions(item?.pickup_instructions)
    }

    const handleUpdateItem = (id, quantity, unit_price) => {
        const salesOrderItemsCopy = [...salesOrderItems]
        const item = salesOrderItemsCopy.find(item => item.id === id)

        item.qty_ordered = toNumber(quantity)
        item.unit_price = unit_price
        item.total_cost = toNumber(quantity) * unit_price

        setSalesOrderItems(salesOrderItemsCopy)
    }

    const handleUpdateItemPurchase = (id, quantity, unit_price) => {
        const purchaseOrderItemsCopy = [...purchaseOrderItems]
        const item = purchaseOrderItemsCopy.find(item => item.id === id)

        item.qty_ordered = toNumber(quantity)
        item.unit_price = unit_price
        item.total_cost = toNumber(quantity) * unit_price

        setPurchaseOrderItems(purchaseOrderItemsCopy)
    }

    const handleUpdateItemQTY = (id, quantity, qts) => {
        const purchaseOrderItemsCopy = [...salesOrderItems]
        const target = purchaseOrderItemsCopy.find(item => item.id === id)
        const nontargets = purchaseOrderItemsCopy.filter(item => item.id !== id)

        target.qty_ordered = toNumber(quantity)
        target.qty_to_ship = toNumber(qts)

        const totalQtyToShip = purchaseOrderItemsCopy.reduce((sum, item) => sum + (item.qty_to_ship || 0), 0);

        if(target.qty_to_ship <= 0) {
            if (totalQtyToShip > 0) {
                target.total_cost = 0;
                nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_to_ship; });
            } else {
                target.total_cost = target.qty_ordered * target.unit_price;
                nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_ordered; });
            }
        } else {
            target.total_cost = target.qty_to_ship * target.unit_price;
            nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_to_ship; });
        }

        setSalesOrderItems(purchaseOrderItemsCopy)
    }

    const handleUpdateItemQTYPurchase = (id, quantity, qts) => {
        const purchaseOrderItemsCopy = [...purchaseOrderItems]
        const target = purchaseOrderItemsCopy.find(item => item.id === id)
        const nontargets = purchaseOrderItemsCopy.filter(item => item.id !== id)

        target.qty_ordered = toNumber(quantity)
        target.qty_to_receive = toNumber(qts)

        const totalQtyToReceive = purchaseOrderItemsCopy.reduce((sum, item) => sum + (item.qty_to_receive || 0), 0);

        if(target.qty_to_receive <= 0) {
            if (totalQtyToReceive > 0) {
                target.total_cost = 0;
                nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_to_receive; });
            } else {
                target.total_cost = target.qty_ordered * target.unit_price;
                nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_ordered; });
            }
        } else {
            target.total_cost = target.qty_to_receive * target.unit_price
            nontargets.forEach(item => { item.total_cost = item.unit_price * item.qty_to_receive; });
        }

        setPurchaseOrderItems(purchaseOrderItemsCopy)
    }

    const handleOpenSalesOrderItem = () => {
        setDisabled(true)
        setOpenSalesOrderItem(!openSalesOrderItem)
    }

    const handleOpenPurchaseOrderItem = () => {
        setDisabled(true)
        setOpenPurchaseOrderItem(!openPurchaseOrderItem)
    }


    /* API Requests */

    const getSalesContractItems = async (_shipAddressId) => {
        if(_shipAddressId == initialShipAddressId) {
            setSalesOrderItems(initialSalesOrderItems)
            return;
        }

        setIsLoading(true)
        await axios
            .get(`/api/sales-contracts?customer_id=${customer?.id}&ship_address_id=${_shipAddressId}`, config)
            .then(({ data }) => setSCItems(data[0]?.sales_contract_items ?? []))
            .finally(() => setIsLoading(false))
    }

    const getPurchaseContractItems = async (_purchaseAddressId) => {
        if(_purchaseAddressId == initialPurchaseAddressId) {
            setPurchaseOrderItems(initialPurchaseOrderItems)
            return;
        }

        setIsLoading(true)
        await axios
            .get(`/api/purchase-contracts?vendor_id=${vendor?.id}&purchase_address_id=${_purchaseAddressId}`, config)
            .then(({ data }) => setPCItems(data[0]?.purchase_contract_items ?? []))
            .finally(() => setIsLoading(false))
    }

    const getCustomers = async (id) => {
        setIsLoading(true)

        setCustomerInputValue('')

        await axios
            .get(`/api/customers?company_id=${id}&blocked=0`, config)
            .then(({ data }) => {
                const _customers = data;
                setCustomers(_customers);

                const _customer = _customers.find((c) => c.id == initialCustomerId);
                if(_customer) {
                    setCustomer({
                        label: _customer?.customer_no + ' - ' + _customer?.name,
                        id: _customer?.id
                    });
                }
            })
            .finally(() => setIsLoading(false))
    }

    const getVendors = async (id) => {
        setIsLoading(true)

        setVendorInputValue('')
        setTplVendorInputValue('')

        await axios
            .get(`/api/vendors?company_id=${id}&blocked=0`, config)
            .then(({ data }) => {
                const _vendors = data
                setVendors(_vendors)

                const _vendor = _vendors.find((v) => v.id == initialVendorId);
                if(_vendor) {
                    setVendor({
                        label: _vendor?.vendor_no + ' - ' + _vendor?.name,
                        id: _vendor?.id
                    });
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const getShipToLocations = async (id) => {
        setIsLoading(true)
        await axios
            .get(`/api/ship-addresses?customer_id=${id}`, config)
            .then(({ data }) => {
                const _addresses = data
                setShipToLocations(_addresses)
                const address = _addresses.find((_address) => _address.id == initialShipAddressId)
                if(address) {
                    setAddress(address?.address ?? '')
                    setZip(address?.zip ?? '')
                    setCity(address.city ?? '')
                    setState(address?.state ?? '')
                    setDeliveryInstructions(address?.delivery_instructions ?? '')
                } else {
                    setShipToAddressId(_addresses[0]?.id ?? '')
                    setAddress(_addresses[0]?.address ?? '')
                    setZip(_addresses[0]?.zip ?? '')
                    setCity(_addresses[0]?.city ?? '')
                    setState(_addresses[0]?.state ?? '')
                    setDeliveryInstructions(_addresses[0]?.delivery_instructions ?? '')
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const getPurchaseLocations = async (id) => {
        setIsLoading(true)
        await axios
            .get(`/api/purchase-addresses?vendor_id=${id}`, config)
            .then(({ data }) => {
                const _addresses = data
                setPurchaseLocations(_addresses)
                const address = _addresses.find((_address) => _address.id == initialPurchaseAddressId)
                if(address) {
                    setAddressVendor(address?.address ?? '')
                    setZipVendor(address?.zip ?? '')
                    setCityVendor(address.city ?? '')
                    setStateVendor(address?.state ?? '')
                    setPickupInstructions(address?.pickup_instructions ?? '')
                } else {
                    setPurchaseAddressId(_addresses[0]?.id ?? '')
                    setAddressVendor(_addresses[0]?.address ?? '')
                    setZipVendor(_addresses[0]?.zip ?? '')
                    setCityVendor(_addresses[0]?.city ?? '')
                    setStateVendor(_addresses[0]?.state || '')
                    setPickupInstructions(_addresses[0]?.pickup_instructions ?? '')
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    /*
     * Template fill sets customerId/shipToAddressId directly from the template, so unlike
     * getShipToLocations() this must NOT reset shipToAddressId to the request's original address -
     * it only needs to populate the dropdown options and the address/instructions display
     * for the id the template already chose.
     */
    const getShipToLocationsForTemplate = async (templateCustomerId, templateShipToAddressId) => {
        setIsLoading(true)
        await axios.get(`/api/ship-addresses?customer_id=${templateCustomerId}`, config)
            .then(({ data }) => {
                const _addresses = data
                setShipToLocations(_addresses)
                const match = _addresses.find((item) => item.id === templateShipToAddressId)
                setAddress(match?.address || '')
                setZip(match?.zip || '')
                setCity(match?.city || '')
                setState(match?.state || '')
                setDeliveryInstructions(match?.delivery_instructions || '')
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    /*
     * Template fill sets vendorId/purchaseAddressId directly from the template, so unlike
     * getPurchaseLocations() this must NOT reset purchaseAddressId to the request's original address -
     * it only needs to populate the dropdown options and the address/instructions display
     * for the id the template already chose.
     */
    const getPurchaseLocationsForTemplate = async (templateVendorId, templatePurchaseAddressId) => {
        setIsLoading(true)
        await axios
            .get(`/api/purchase-addresses?vendor_id=${templateVendorId}`, config)
            .then(({ data }) => {
                const _addresses = data
                setPurchaseLocations(_addresses)
                const match = _addresses.find((item) => item.id === templatePurchaseAddressId)
                setAddressVendor(match?.address || '')
                setZipVendor(match?.zip || '')
                setCityVendor(match?.city || '')
                setStateVendor(match?.state || '')
                setPickupInstructions(match?.pickup_instructions || '')
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const getTemplates = async (type, params) => {
        setIsLoading(true)

        let url = `/api/templates`;
        switch(type) {
            case 'shipment':
                url = url.concat(`?type=shipment&customer_id=${params?.customerId}&ship_address_id=${params?.shipAddressId}`)
                break;
            case 'collection':
                url = url.concat(`?type=collection&vendor_id=${params?.vendorId}&purchase_address_id=${params?.purchaseAddressId}`)
                break;
            default:
                console.error(`Could not retrieve templates! Reason: unsupported type (${type})`);
                return;
        }
        url = url.concat(`&with_items=true`);

        await axios
            .get(url, config)
            .then(({ data }) => {
                const { data: _data } = data;
                setTemplates(_data);
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const createBrokerTransaction = async (e) => {
        e.preventDefault()

        console.log("Sales Order Items: ", salesOrderItems);
        console.log("Purchase Order Items: ", purchaseOrderItems);

        const mustMatch = ['1', 'true', true, 1].includes(features?.TRANSACTION_QUANTITIES_MUST_MATCH);
        if(mustMatch) {
            const ignoreOthers = ['1', 'true', true, 1].includes(features?.IGNORE_OTHER_ITEMS);

            let salesOrderItemsCopy = salesOrderItems;
            let purchaseOrderItemsCopy = purchaseOrderItems;

            if(ignoreOthers) {
                salesOrderItemsCopy = salesOrderItemsCopy.filter((item) => item?.unit_type !== 'other');
                purchaseOrderItemsCopy = purchaseOrderItemsCopy.filter((item) => item?.unit_type !== 'other');
            }

            const salesOrdersSum = salesOrderItemsCopy.reduce((accumulator, current) => accumulator + toNumber(current.qty_ordered), 0)
            const purchaseOrdersSum = purchaseOrderItemsCopy.reduce((accumulator, current) => accumulator + toNumber(current.qty_ordered), 0)
            if(salesOrdersSum !== purchaseOrdersSum) {
                Swal.fire({
                    text: t('ordered_quantities_not_equal_warning__alt'),
                    icon: "error",
                    customClass: 'error',
                    showCloseButton: true,
                    iconColor: '#FF0000'
                })

                return
            }
        }

        setIsLoading(true)
        const formData = {}

        formData['type'] = type
        formData['logistics_type_id'] = logisticsTypeId
        formData['customer_id'] = customer?.id
        formData['vendor_id'] = vendor?.id
        formData['ship_address_id'] = shipToAddressId
        formData['purchase_address_id'] = purchaseAddressId
        formData['drop_trailer_no'] = dropTrailerNo
        formData['pickup_trailer_no'] = pickupTrailerNo
        formData['customer_po_no'] = customerPoNo
        formData['customer_bol_no'] = bolNo
        formData['requested_delivery_date'] = dayjs(requestedDeliveryDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        formData['delivery_time'] = deliveryTime
        formData['shipment_date'] = dayjs(shippedDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        formData['site_id'] = request?.site_id ?? choosesite
        formData['sales_order_items'] = salesOrderItems
        formData['purchase_order_items'] = purchaseOrderItems
        formData['comments'] = comments
        formData['request_creator_comments'] = requestCreatorComments

        formData['request_id'] = request.id

        if(deliveryTime === 'appointment') {
            switch(logisticsTypeKey) {
                case "delivery":
                    formData['requested_delivery_time'] = dayjs(requestedDeliveryTime).endOf('minute').format('YYYY-MM-DD HH:mm:ss')
                    break
                case "pick_up":
                    formData['pickup_appointment_time'] = dayjs(pickupAppointmentTime).endOf('minute').format('YYYY-MM-DD HH:mm:ss')
                    break
                case "tpl":
                    formData['requested_delivery_time'] = dayjs(requestedDeliveryTime).endOf('minute').format('YYYY-MM-DD HH:mm:ss')
                    formData['pickup_appointment_time'] = dayjs(pickupAppointmentTime).endOf('minute').format('YYYY-MM-DD HH:mm:ss')
                    break
                default:
            }
        }

        if(logisticsTypeKey === 'tpl') {
            formData['tpl_vendor_id'] = tplVendor?.id
            formData['delivery_cost'] = deliveryCost
        }

        if(selectedTemplate) {
            formData['transaction_template_id'] = selectedTemplate.id
        }

        const url = type === 'shipment'
            ? `/api/broker-shipment-requests/accept-request/${request.id}`
            : `/api/broker-collection-requests/accept-request/${request.id}`

        await axios
            .put(url, formData, config).then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    customClass: 'success',
                    showCloseButton: true,
                    iconColor: '#00B78E',
                    text: data.success.message
                })

                navigate("/broker-transactions/" + data.success.updated.bt_id)

                handleToggleModal()
            })
            .catch(({ response }) => {
                handleAxiosError({response: response})
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const columns = [
        {
            field: 'item_no',
            headerName: t('no'),
            flex: 0.7,
            minWidth: 75
        },
        {
            field: 'description',
            headerName: t('description'),
            flex: 1.5,
            maxWidth: 140
        },
        {
            field: 'unit_of_measure_code',
            headerName: t('uom'),
            flex: 0.7,
            minWidth: 75
        },
        {
            field: 'qty_ordered',
            headerName: type === 'collection' ? t('qty_expected') : t('qty_ordered'),
            flex: 1,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <QtyOrderedSalesCell params={params} handler={handleUpdateItem} handlerQTR={handleUpdateItemQTY} />
        },
        {
            field: 'qty_to_ship',
            headerName: type === 'collection' ? t('qty_loaded') : t('qty_shipped'),
            flex: 1,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <QtyToShipSalesCell params={params} t={t} handlerQTR={handleUpdateItemQTY} />
        },
        {
            field: 'qty_shipped',
            headerName: type === 'collection' ? t('qty_received') : t('qty_delivered'),
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => <QtyShippedSalesCell params={params} />
        },
        {
            field: 'unit_price',
            headerName: t('unit_price'),
            flex: 0.7,
            minWidth: 75,
            renderCell: (params) => <UnitPriceSalesCell params={params} currencySymbol={currencySymbol} />
        },
        {
            field: 'total_cost',
            headerName: t('total'),
            flex: 0.7,
            minWidth: 75,
            renderCell: (params) => <TotalSalesCell params={params} currencySymbol={currencySymbol} />
        },
        {
            field: 'actions',
            headerName: t('actions'),
            sortable: false,
            flex: 0.5,
            minWidth: 50,
            cellClassName: 'padding-0',
            renderCell: (params) => <Actions params={params} t={t} salesOrderItems={salesOrderItems} setSalesOrderItems={setSalesOrderItems} />
        },
    ]

    const columnsPurchase = [
        {
            field: 'item_no',
            headerName: t('no'),
            flex: 0.7,
            minWidth: 75
        },
        {
            field: 'description',
            headerName: t('description'),
            flex: 1.5,
            maxWidth: 140
        },
        {
            field: 'unit_of_measure_code',
            headerName: t('uom'),
            flex: 0.7,
            minWidth: 75
        },
        {
            field: 'qty_ordered',
            headerName: type === 'collection' ? t('qty_expected') : t('qty_ordered'),
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => <QtyOrderedPurchaseCell params={params} handler={handleUpdateItemPurchase} handlerQTR={handleUpdateItemQTYPurchase} />
        },
        {
            field: 'qty_to_receive',
            headerName: type === 'collection' ? t('qty_loaded') : t('qty_shipped'),
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            minWidth: 100,
            renderCell: (params) => <QtyToReceivePurchaseCell params={params} t={t} handlerQTR={handleUpdateItemQTYPurchase} />
        },
        {
            field: 'qty_received',
            headerName: type === 'collection' ? t('qty_received') : t('qty_delivered'),
            flex: 1,
            minWidth: 100,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <QtyReceivedPurchaseCell params={params} />
        },
        {
            field: 'unit_price',
            headerName: t('unit_price'),
            flex: 0.7,
            minWidth: 75,
            renderCell: (params) => <UnitPricePurchaseCell params={params} currencySymbol={currencySymbol} />
        },
        {
            field: 'total_cost',
            headerName: t('total'),
            flex: 0.7,
            minWidth: 75,
            renderCell: (params) => <TotalPurchaseCell params={params} currencySymbol={currencySymbol} />
        },
        {
            field: 'actions',
            headerName: t('actions'),
            sortable: false,
            flex: 0.5,
            minWidth: 50,
            cellClassName: 'padding-0',
            renderCell: (params) => <ActionsPurchase params={params} t={t} salesOrderItems={purchaseOrderItems} setSalesOrderItems={setPurchaseOrderItems} />
        },
    ]

    const optionsTplVendors = vendors?.filter((vendor) => vendor.shipping_code == '3PL').map((option) => ({
        label: option.vendor_no + ' - ' + option.name,
        id: option.id
    }))

    const NO_TEMPLATE_OPTIONS = { label: t('no_options'), id: 0, data: null }
    const templateOptions = templates?.length > 0
        ? templates.map(option => ({ label: option.name, id: option.id, data: {...option} }))
        : [NO_TEMPLATE_OPTIONS]

    return (
        <>
            <Modal open={open} onClose={handleToggleModal}>
                <Box sx={style}>
                    <div className='flex justify-between items-center p-5 w-full bg-white' style={{ borderRadius: '5px 5px 0 0' }}>
                        <div className='flex items-center justify-between w-full leading-none'>
                            <p className='text-[18px] font-[600] text-[#333333] flex items-center'><span className='text-[#148c8cb3] text-[35px] mr-4'>•</span> {t('create_new_broker')}</p>
                            <div style={{ transform: "rotate(45deg)" }} className="font-[600] text-[#333333]">
                                <button onClick={handleToggleModal}><i className="fa-solid fa-plus"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className='p-5 pb-12 flex justify-between gap-3 flex-col lg:flex-row'>
                        <div className='w-full lg:w-2/5'>
                            {/* TYPE SECTION */}
                            <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                <div className='pb-5 pt-1'>
                                    <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('type_of_load')} *</p>
                                </div>
                                <FormControl className='w-full pb-4'>
                                    <RadioGroup
                                        name="broker-transaction-type-radio-button-group"
                                        value={type}
                                        row
                                    >
                                        <FormControlLabel value="shipment" control={<Radio disabled />} label={t('shipment')} />
                                        <FormControlLabel value="collection" control={<Radio disabled />} label={t('collection')} />
                                    </RadioGroup>
                                </FormControl>
                            </div>

                            {/* LOGISTICS SECTION */}
                            <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                <div className='pb-5 pt-1'>
                                    <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('logistics')} *</p>
                                </div>
                                <div className='w-full pb-4'>
                                    <div className='w-full'>
                                        <Autocomplete
                                            disablePortal
                                            disableClearable
                                            id="logistics-type-autocomplete"
                                            options={filteredLogisticsTypes?.map((type) => ({id: type.id, label: t(type.key), key: type.key}))}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            sx={{
                                                ...AUTOCOMPLETE_STYLE,
                                                '.MuiOutlinedInput-input': {
                                                    padding: '0 !important'
                                                }
                                            }}
                                            onChange={(a, b) => {
                                                setLogisticsTypeId(b?.id || '')
                                                setLogisticsTypeKey(b?.key || '')
                                            }}
                                            renderInput={(params) => <TextField {...params} autoFocus={true} />}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className={clsx(
                                    'flex flex-col', {
                                        'flex-col-reverse': type === 'collection'
                                    }
                                )}
                            >
                                {/* CUSTOMER section */}
                                <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                    <div className='pb-5 pt-1'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{type === 'collection' ? t('service_provider') : t('customer')}</p>
                                    </div>
                                    {/* Customer */}
                                    <div className='w-full pb-4'>
                                        <p className="text-[14px] text-[#718096]">{type === 'collection' ? t('service_provider') : t('customer')}*</p>
                                        <Autocomplete
                                            disabled={type === 'shipment'}
                                            disablePortal
                                            disableClearable
                                            id="customer-autocomplete"
                                            options={customers?.map(option => ({ label: option.customer_no + ' - ' + option.name, id: option.id }))}
                                            /* getOptionDisabled={(option) => option.id == tplVendorId} */
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            sx={{
                                                ...AUTOCOMPLETE_STYLE,
                                                '.MuiOutlinedInput-input': {
                                                    padding: '0 !important'
                                                }
                                            }}
                                            inputValue={customerInputValue}
                                            onInputChange={(e, value) => setCustomerInputValue(value)}
                                            value={customer}
                                            onChange={(a, b) => {
                                                setPrevSelectedTemplate(selectedTemplate);
                                                setSelectedTemplate(null);
                                                setCustomer(b);
                                            }}
                                            renderInput={(params) => <TextField {...params} autoFocus={true} />}
                                        />
                                    </div>
                                    {/* Ship to code */}
                                    {((type == 'shipment' && logisticsTypeKey !== 'pick_up') || (type == 'collection')) ? (
                                        <>
                                            <div className='w-full pb-4'>
                                                <Stack
                                                    direction='row'
                                                    gap={1}
                                                    alignItems='baseline'
                                                    justifyContent='space-between'
                                                >
                                                    <p className="text-[14px] text-[#718096]">{t('ship_to_location')} *</p>
                                                    {(shipToAddressId && isValid(deliveryInstructions)) ? (
                                                        <Tooltip
                                                            title={
                                                                <div style={{ whiteSpace: 'pre-line' }}>
                                                                    {deliveryInstructions}
                                                                </div>
                                                            }
                                                        >
                                                            <Stack
                                                                direction='row'
                                                                gap={1}
                                                                alignItems='center'
                                                                className='text-[#718096]'
                                                            >
                                                                <MenuBookIcon fontSize='18px'/>
                                                                <span className='text-[14px] min-[420px]:block hidden' style={{textTransform: 'uppercase'}}>{t('delivery_instructions')}</span>
                                                            </Stack>
                                                        </Tooltip>
                                                    ) : null}
                                                </Stack>

                                                <div className='w-full'>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <Select
                                                            disabled={type === 'shipment'}
                                                            value={shipToAddressId}
                                                            onChange={(e) => { handleShipToLocation(e) }}
                                                            sx={SELECT_STYLE}
                                                        >
                                                            {shipToLocations?.map((item, index) => <MenuItem key={`stls-${index}`} value={item.id}>{item.code} - {item.name}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                            {/* Address */}
                                            {
                                                shipToAddressId ?
                                                    <div className='w-full p-4 address mb-4'>
                                                        <div className='w-full'>{address}</div>
                                                        {shipToAddressId ? <div className='w-full'>{zip} {city}, {state}</div> : <div className='w-full'></div>}
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </>
                                    ) : (
                                        <div className='w-full p-4 address mb-4'>
                                            <div className='w-full text-[#00000061]'>{t('pick_up')}</div>
                                        </div>
                                    )}
                                    {/* Customer PO No. */}
                                    <div className='w-full'>
                                        <p className="text-[14px] text-[#718096]">{t('customer_po_no')}</p>
                                        <div className='w-full'>
                                            <TextField
                                                sx={TEXTFIELD_STYLE}
                                                type="text"
                                                name="customer_po_no"
                                                value={customerPoNo}
                                                onChange={(e) => { handleCustomerPoNo(e) }}
                                            />
                                            <p className='text-xs italic roboto text-slate-500 pt-1'>
                                                <i className="fa-solid fa-circle-info"></i> {t('the_maximum_character_limit_is_x', { x: 50 })}.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* TEMPLATE section */}
                                <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                    <div className='pb-5 pt-1'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('template')}</p>
                                    </div>
                                    <div className='w-full'>
                                        <Autocomplete
                                            disabled={templates.length <= 0}
                                            disablePortal
                                            disableClearable
                                            id="template-autocomplete"
                                            options={templateOptions}
                                            getOptionDisabled={(option) => option.data === null}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            sx={{
                                                ...AUTOCOMPLETE_STYLE,
                                                '.MuiOutlinedInput-input': {
                                                    padding: '0 !important'
                                                }
                                            }}
                                            value={
                                                templates.length <= 0
                                                    ? NO_TEMPLATE_OPTIONS
                                                    : selectedTemplate
                                                        ? {label: `${selectedTemplate.name}`, id: selectedTemplate.id, data: {...selectedTemplate}}
                                                        : prevSelectedTemplate
                                                            ? {label: `${prevSelectedTemplate?.name}`, id: null, data: null}
                                                            : null
                                            }
                                            onChange={(a, b) => setSelectedTemplate(b?.data || null)}
                                            renderInput={(params) => <TextField {...params} autoFocus={true} />}
                                        />
                                    </div>
                                </div>

                                {/* SUPPLIER section */}
                                <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                    <div className='pb-5 pt-1'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{type === 'collection' ? t('supplier') : t('vendor')}</p>
                                    </div>
                                    {/* Vendor */}
                                    <div className='w-full pb-4'>
                                        <p className="text-[14px] text-[#718096]">{t('supplier')} *</p>
                                        <Autocomplete
                                            disabled={type === 'collection'}
                                            disablePortal
                                            disableClearable
                                            id="vendor-autocomplete"
                                            options={vendors?.map(option => ({ label: option.vendor_no + ' - ' + option.name, id: option.id }))}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            getOptionDisabled={(option) => option.id === tplVendor?.id}
                                            sx={{
                                                ...AUTOCOMPLETE_STYLE,
                                                '.MuiOutlinedInput-input': {
                                                    padding: '0 !important'
                                                }
                                            }}
                                            inputValue={vendorInputValue}
                                            onInputChange={(e, value) => setVendorInputValue(value)}
                                            value={vendor}
                                            onChange={(a, b) => {
                                                setPrevSelectedTemplate(selectedTemplate);
                                                setSelectedTemplate(null);
                                                setVendor(b);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </div>

                                    {/* Purchase Location */}
                                    <div className='w-full pb-4'>
                                        <Stack
                                            direction='row'
                                            gap={1}
                                            alignItems='baseline'
                                            justifyContent='space-between'
                                        >
                                            <p className="text-[14px] text-[#718096]">{t('purchaseLocation')} *</p>
                                            {(purchaseAddressId && isValid(pickupInstructions)) ? (
                                                <Tooltip
                                                    title={
                                                        <div style={{ whiteSpace: 'pre-line' }}>
                                                            {pickupInstructions}
                                                        </div>
                                                    }
                                                >
                                                    <Stack
                                                        direction='row'
                                                        gap={1}
                                                        alignItems='center'
                                                        className='text-[#718096]'
                                                    >
                                                        <MenuBookIcon fontSize='18px'/>
                                                        <span className='text-[14px] min-[420px]:block hidden' style={{textTransform: 'uppercase'}}>{t('pickup_instructions')}</span>
                                                    </Stack>
                                                </Tooltip>
                                            ) : null}
                                        </Stack>

                                        <div className='w-full'>
                                            <FormControl sx={{ width: '100%' }}>
                                                <Select
                                                    disabled={type === 'collection'}
                                                    value={purchaseAddressId}
                                                    onChange={(e) => { handlePurchaseLocation(e) }}
                                                    sx={SELECT_STYLE}
                                                >
                                                    {purchaseLocations?.map((item, index) => <MenuItem key={`pls-${index}`} value={item.id}>{item.code} - {item.name}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>

                                    {/* Address */}
                                    {
                                        purchaseAddressId ?
                                            <div className='w-full p-4 address mb-4'>
                                                <div className='w-full'>{addressVendor}</div>
                                                {purchaseAddressId ? <div className='w-full'>{zipVendor} {cityVendor}, {stateVendor}</div> : <div className='w-full'></div>}
                                            </div>
                                            :
                                            null
                                    }

                                    {/* Bol No. */}
                                    <div className='w-full'>
                                        <p className="text-[14px] text-[#718096]">{t('bol_number')}</p>
                                        <div className='w-full'>
                                            <TextField
                                                sx={TEXTFIELD_STYLE}
                                                type="text"
                                                name="pickup_trailer_no"
                                                value={bolNo}
                                                onChange={(e) => { setBolNo(e.target.value) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* 3PL COMPANY section */}
                            {logisticsTypeKey === 'tpl' ? (
                                <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view mb-3'>
                                    <div className='pb-5 pt-1'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('tpl_company')}</p>
                                    </div>
                                    {/* 3PL Vendor */}
                                    <div className='w-full pb-4'>
                                        <p className="text-[14px] text-[#718096]">{t('tpl_vendor')} *</p>
                                        <div className='w-full'>
                                            <Autocomplete
                                                disablePortal
                                                disableClearable
                                                id="tpl-vendor-autocomplete"
                                                options={optionsTplVendors}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                getOptionDisabled={(option) => option.id === vendor?.id}
                                                sx={AUTOCOMPLETE_STYLE}
                                                inputValue={tplVendorInputValue}
                                                onInputChange={(e, value) => setTplVendorInputValue(value)}
                                                value={tplVendor}
                                                onChange={(a, b) => setTplVendor(b)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                    </div>

                                    <div className='w-full'>
                                        <p className="text-[14px] text-[#718096]">{t('delivery_cost')} ({currencySymbol}) *</p>
                                        <div className='w-full'>
                                            <TextField
                                                sx={TEXTFIELD_STYLE}
                                                type="text"
                                                className='w-full'
                                                name="delivery_cost"
                                                value={deliveryCost}
                                                onChange={(e) => handleNumber({
                                                    event: e,
                                                    setter: setDeliveryCost,
                                                    precision: 2
                                                })}
                                                onBlur={e => handleZero({
                                                    event: e,
                                                    setter: setDeliveryCost
                                                })}
                                                onFocus={e => deleteZero({
                                                    event: e,
                                                    setter: setDeliveryCost,
                                                    value: deliveryCost
                                                })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : null}

                            {/* GENERAL INFORMATION section */}
                            <div className='bg-white p-6 pt-0 rounded-md w-full h-fit edit-view '>
                                <div className='pb-5 pt-1'>
                                    <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('general_information')}</p>
                                </div>

                                <div className='w-full pb-4'>
                                    <p className="text-[14px] text-[#718096]">{t('drop_trailer_no')}</p>
                                    <div className='w-full'>
                                        <TextField
                                            sx={TEXTFIELD_STYLE}
                                            type="text"
                                            name="drop_trailer_no"
                                            value={dropTrailerNo}
                                            onChange={(e) => { setDropTrailerNo(e.target.value) }}
                                        />
                                    </div>
                                </div>
                                {/* Pickup Trailer No. */}
                                <div className='w-full pb-4'>
                                    <p className="text-[14px] text-[#718096]">{t('pickup_trailer_no')}</p>
                                    <div className='w-full'>
                                        <TextField
                                            sx={TEXTFIELD_STYLE}
                                            type="text"
                                            name="pickup_trailer_no"
                                            value={pickupTrailerNo}
                                            onChange={(e) => { setPickupTrailerNo(e.target.value) }}
                                        />
                                    </div>
                                </div>

                                {/* Requested Delivery|Collection Date */}
                                <div className='w-full pb-4'>
                                    <p className="text-[14px] text-[#718096]">{type === 'collection' ? t('requested_collection_date') : t('requested_delivery_date')} *</p>
                                    <div className='w-full'>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <MobileDatePicker
                                                sx={MOBILE_DATE_PICKER_STYLE}
                                                format="YYYY-MM-DD"
                                                value={requestedDeliveryDate}
                                                onChange={(newValue) => setRequestedDeliveryDate(newValue)}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </div>

                                {/* Delivery Time */}
                                {!(
                                    type === 'collection'
                                    && logisticsTypeKey === 'pick_up'
                                ) ? (
                                    <div className='w-full pb-4'>
                                        <p className="text-[14px] text-[#718096]">{t('delivery_time')} *</p>
                                        <div className='w-full'>
                                            <FormControl sx={{ width: '100%' }}>
                                                <Select
                                                    value={deliveryTime}
                                                    onChange={(e) => { setDeliveryTime(e.target.value) }}
                                                    sx={SELECT_STYLE}
                                                >
                                                    <MenuItem value={'first_come_first_served'}>{t('first_come_first_served')}</MenuItem>
                                                    <MenuItem value={'appointment'}>{t('appointment')}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                ) : null}

                                {/* Appointment Time(s) */}
                                {deliveryTime === 'appointment' && includes(['delivery', 'pick_up', 'tpl'], logisticsTypeKey) ? (
                                    <div className={`w-full pb-4 ${logisticsTypeKey === 'tpl' ? 'flex flex-row gap-x-1.5' : null}`}>
                                        {includes(['pick_up', 'tpl'], logisticsTypeKey) && (
                                            <div className={`${logisticsTypeKey === 'tpl' ? 'w-1/2' : 'w-full'}`}>
                                                <p className="text-[14px] text-[#718096]">{t('pickup_appointment_time')} *</p>
                                                <div className="w-full">
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer sx={{ padding: '0' }} components={['TimePicker', 'TimePicker']}>
                                                            <MobileTimePicker
                                                                sx={MOBILE_TIME_PICKER_STYLE}
                                                                value={pickupAppointmentTime}
                                                                onChange={(newValue) => setPickupAppointmentTime(newValue)}
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                        )}
                                        {includes(['delivery', 'tpl'], logisticsTypeKey) && (
                                            <div className={`${logisticsTypeKey === 'tpl' ? 'w-1/2' : 'w-full'}`}>
                                                <p className="text-[14px] text-[#718096]">{t('delivery_appointment_time')} *</p>
                                                <div className='w-full'>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DemoContainer sx={{ padding: '0' }} components={['TimePicker', 'TimePicker']}>
                                                            <MobileTimePicker
                                                                sx={MOBILE_TIME_PICKER_STYLE}
                                                                value={requestedDeliveryTime}
                                                                onChange={(newValue) => setRequestedDeliveryTime(newValue)}
                                                            />
                                                        </DemoContainer>
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : null}

                                {/* Shippment Date */}
                                {!localStorage.getItem('client_id').includes('pallet-book') && (
                                    <div className='w-full'>
                                        <p className="text-[14px] text-[#718096]">{t('shipment_date')}</p>
                                        <div className='w-full'>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <MobileDatePicker
                                                    sx={MOBILE_TIME_PICKER_STYLE}
                                                    format="YYYY-MM-DD"
                                                    value={shippedDate}
                                                    onChange={(newValue) => setShippedDate(newValue)}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='w-full lg:w-3/5'>
                            <div
                                className={clsx(
                                    'flex flex-col', {
                                        'flex-col-reverse': type === 'collection'
                                    }
                                )}
                            >
                                {/* Sales Order Items */}
                                <div className='bg-white pt-0 rounded-md w-full edit-view mb-3'>
                                    <div className='pt-1 pl-3'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('salesOrderitems')}</p>
                                    </div>
                                    <div className='flex justify-end p-5 pt-0 border-b'>
                                        <Tooltip disableInteractive title={t('addsalesOrderitems')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={disabledButtonSales} onClick={handleOpenSalesOrderItem}><i className="fa-solid fa-plus"></i></AddButton>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className='border-b'>
                                        {
                                            salesOrderItems.length > 0 ?
                                                <div className='flex justify-end w-full p-2'>
                                                    <button className='px-2 py-1 text-white bg-red-600 font-bold rounded-md mb-1 roboto text-xs uppercase' onClick={e => setSalesOrderItems([])}>{t('clear_all')}</button>
                                                </div>
                                                :
                                                null
                                        }
                                        <TableShared columns={columns} items={salesOrderItems} disableColumnMenu={true} />
                                    </div>
                                    <div className='flex justify-end w-full p-5'>
                                        <div className='w-full lg:w-1/3'>
                                            <div className='flex justify-between text-[#333333] text-[15px] pb-4'>
                                                <p>{t('totalPrice')}</p>
                                                <p className='font-[500]'>{currencySymbol}{totalPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                            </div>
                                            <div className='flex justify-between text-[#333333] text-[15px]'>
                                                <p>{t('totalQty')}</p>
                                                <p className='font-[500]'>{totalQty}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Purchase Order Items */}
                                <div className='bg-white pt-0 rounded-md w-full edit-view mb-3'>
                                    <div className='pt-1 pl-3'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('purchaseOrderItems')}</p>
                                    </div>
                                    <div className='flex justify-end p-5 pt-0 border-b'>
                                        <Tooltip disableInteractive title={t('addpurchaseOrderItems')} placement='bottom'>
                                            <div>
                                                <AddButton disabled={disabledButtonPurchase} onClick={handleOpenPurchaseOrderItem}><i className="fa-solid fa-plus"></i></AddButton>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className='border-b'>
                                        {
                                            purchaseOrderItems.length > 0 ?
                                                <div className='flex justify-end w-full p-2'>
                                                    <button className='px-2 py-1 text-white bg-red-600 font-bold rounded-md mb-1 roboto text-xs uppercase' onClick={e => setPurchaseOrderItems([])}>{t('clear_all')}</button>
                                                </div>
                                                :
                                                null
                                        }
                                        <TableShared columns={columnsPurchase} items={purchaseOrderItems} disableColumnMenu={true} />
                                    </div>

                                    <div className='flex justify-end w-full p-5'>
                                        <div className='w-full lg:w-1/3'>
                                            <div className='flex justify-between text-[#333333] text-[15px] pb-4'>
                                                <p>{t('totalPrice')}</p>
                                                <p className='font-[500]'>{currencySymbol}{totalPricePurchase.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                                            </div>
                                            <div className='flex justify-between text-[#333333] text-[15px]'>
                                                <p>{t('totalQty')}</p>
                                                <p className='font-[500]'>{totalQtyPurchase}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='w-full'>
                                <div className='bg-white pt-0 rounded-md w-full edit-view mb-3'>
                                    <div className='pt-1 p-5'>
                                        <p className='text-[13px] font-[600] uppercase text-[#A1ACB8]'>{t('comments')}</p>
                                    </div>
                                    <div className='w-full p-5 pt-0'>
                                        <p className="text-[14px] text-[#718096]">{t('comments_text')}</p>
                                        <TextField
                                            multiline
                                            rows={3}
                                            value={comments}
                                            onChange={e => setComments(e.target.value)}
                                            sx={TEXTFIELD_STYLE}
                                        />
                                    </div>

                                    <div className='w-full p-5 pt-0'>
                                        <p className="text-[14px] text-[#718096]">{t('request_creator_comments')}</p>
                                        <TextField
                                            multiline
                                            rows={3}
                                            sx={TEXTFIELD_STYLE}
                                            disabled
                                            value={requestCreatorComments}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex justify-end'>
                                <button type="button" onClick={createBrokerTransaction} className='text-white font-[700] rounded-md py-2.5 px-5 uppercase text-[14px] bg-[#DBA34B] hover:bg-[#CF7300] disabled:bg-[#B8B7BC]'>
                                    <span className='pr-2'><i className="fa-solid fa-plus"></i></span> {t('create')}
                                </button>
                            </div>
                        </div>
                    </div>
                </Box>
            </Modal >
            <AddSalesOrderItem open={openSalesOrderItem} handleOpen={handleOpenSalesOrderItem} salesOrderItems={salesOrderItems} setSalesOrderItems={setSalesOrderItems} disabled={disabled} setDisabled={setDisabled} purchaseOrderItems={purchaseOrderItems} setPurchaseOrderItems={setPurchaseOrderItems} />
            <AddPurchaseOrderItem open={openPurchaseOrderItem} handleOpen={handleOpenPurchaseOrderItem} purchaseOrderItems={purchaseOrderItems} setPurchaseOrderItems={setPurchaseOrderItems} disabled={disabled} setDisabled={setDisabled} salesOrderItems={salesOrderItems} setSalesOrderItems={setSalesOrderItems} />
            <UnevenQuantitiesModal
                open={openUnevenQuantitiesModal}
                setOpen={setOpenUnevenQuantitiesModal}
                continueHandler={createBrokerTransaction}
                t={t}
            />
        </>
    )
}



export default CreateBrokerTransactionCustomerUser

const maxQtyDigits = 5

{/* SALES ORDER ITEM cells */}

const QtyOrderedSalesCell = ({ params, handler, handlerQTR }) => {
    const [qty, setQty] = useState(params.value)

    useEffect(() => {
        setQty(params.value)
    }, [params.row.qty_ordered])

    const handleZeroLocal = (e) => {
        if (e.target.value === "" || e.target.value === '-') {
            setQty(0)

            handler(
                params.row.id,
                0,
                params.row.unit_price
            )
        }
    }

    const handleQuantity = (e) => {
        const regex = createRegexFromString(`/^(-?\\d{0,${maxQtyDigits}})$/i`)
        if (regex.test(e.target.value)) {
            if (e.target.value < 0 || e.target.value === '-') {
                setQty(0)
            } else {
                if (e.target.value < params.row.qty_to_ship) {
                    setQty(e.target.value)

                    handlerQTR(
                        params.row.id,
                        e.target.value,
                        params.row.qty_to_ship
                    )
                    handler(
                        params.row.id,
                        e.target.value,
                        params.row.unit_price
                    )
                } else {
                    setQty(e.target.value)

                    handler(
                        params.row.id,
                        e.target.value,
                        params.row.unit_price
                    )
                }
            }
        }
    }

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-ordered"
            value={qty}
            onChange={(e) => handleQuantity(e) }
            onBlur={handleZeroLocal}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
        />
    )
}

const QtyToShipSalesCell = ({ params, t, handlerQTR }) => {
    const [qty, setQty] = useState(params.value)

    useEffect(() => {
        setQty(params.value)
    }, [params.row.qty_ordered])

    const handleQuantity = (e) => {
        const regex = createRegexFromString(`/^(-?\\d{0,${maxQtyDigits}})$/i`)
        if (regex.test(e.target.value)) {
            if (e.target.value < 0 || e.target.value === '-') {
                setQty(0)
            } else {
                if (e.target.value > params.row.qty_ordered) {
                    setQty(params.row.qty_ordered)
                    handlerQTR(
                        params.row.id,
                        params.row.qty_ordered,
                        params.row.qty_ordered
                    )
                    Swal.fire({
                        text: t('warningSalesOrder'),
                        icon: 'warning',
                        customClass: 'error',
                        showCloseButton: true,
                        iconColor: '#FF0000',
                        reverseButtons: true,
                    })
                } else {
                    setQty(e.target.value)
                    handlerQTR(
                        params.row.id,
                        params.row.qty_ordered,
                        e.target.value,
                    )
                }
            }
        }
    }

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-to-ship-sales"
            value={qty}
            onChange={(e) => handleQuantity(e) }
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
            disabled
        />
    )
}

const QtyShippedSalesCell = ({ params }) => {
    const [qty, setQty] = useState(params.value)

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-shipped-sales"
            value={qty}
            onChange={(e) => handleInteger({
                event: e,
                setter: setQty,
                end: 30
            })}
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
            disabled
        />
    )
}

const UnitPriceSalesCell = (params) => {
    return (
        <>{params.currencySymbol}{params.params.row.unit_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
    )
}

const TotalSalesCell = ({ params, currencySymbol }) => {
    const { value, row } = params;

    const [total, setTotal] = useState(value)

    useEffect(() => {
        setTotal(row.total_cost);
    }, [params])

    return (
        <>{currencySymbol}{total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
    )
}

const Actions = ({ params, t, salesOrderItems, setSalesOrderItems }) => {
    const deleteItem = async (id) => {
        const filtered = salesOrderItems.filter(i => i.id != id)
        setSalesOrderItems(filtered)
    }

    return (
        <>
            <div className='flex justify-between'>
                <Tooltip disableInteractive title={t('delete')} placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200" onClick={() => deleteItem(params.row.id)}><i className="fa-solid fa-trash"></i></span>
                    </div>
                </Tooltip>
            </div>
        </>
    )
}

{/* PURCHASE ORDER ITEM cells */}

const QtyOrderedPurchaseCell = ({ params, handler, handlerQTR }) => {
    const [qty, setQty] = useState(params.value)

    useEffect(() => {
        setQty(params.value)
    }, [params.row.qty_ordered])

    const handleZeroLocal = (e) => {
        if (e.target.value === "") {
            setQty(0)

            handler(
                params.row.id,
                0,
                params.row.unit_price
            )
        }
    }

    const handleQuantity = (e) => {
        const regex = createRegexFromString(`/^(-?\\d{0,${maxQtyDigits}})$/i`)
        if (regex.test(e.target.value)) {
            if (e.target.value < 0 || e.target.value === '-') {
                setQty(0)
            } else {
                if (e.target.value < params.row.qty_to_receive) {
                    setQty(e.target.value)

                    handlerQTR(
                        params.row.id,
                        e.target.value,
                        params.row.qty_to_receive
                    )
                    handler(
                        params.row.id,
                        e.target.value,
                        params.row.unit_price
                    )
                } else {
                    setQty(e.target.value)

                    handler(
                        params.row.id,
                        e.target.value,
                        params.row.unit_price
                    )
                }
            }
        }
    }

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-ordered-purchase"
            value={qty}
            onChange={(e) => handleQuantity(e) }
            onBlur={handleZeroLocal}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
        />
    )
}

const QtyToReceivePurchaseCell = ({ params, t, handlerQTR }) => {
    const [qty, setQty] = useState(params.value)

    useEffect(() => {
        setQty(params.value)
    }, [params.row.qty_ordered])

    const handleQuantity = (e) => {
        const regex = createRegexFromString(`/^(-?\\d{0,${maxQtyDigits}})$/i`)
        if (regex.test(e.target.value)) {
            if (e.target.value < 0 || e.target.value === '-') {
                setQty(0)
            } else {
                if (e.target.value > params.row.qty_ordered) {
                    setQty(params.row.qty_ordered)
                    handlerQTR(
                        params.row.id,
                        params.row.qty_ordered,
                        params.row.qty_ordered
                    )
                    Swal.fire({
                    icon: "warning",
                    text: t('warningPurchaseOrder'),
                    customClass: 'warning2',
                    showCloseButton: true,
                    iconColor: '#FFCA28'
                })
                } else {
                    setQty(e.target.value)
                    handlerQTR(
                        params.row.id,
                        params.row.qty_ordered,
                        e.target.value
                    )
                }
            }
        }
    }

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-to-receive-purchase"
            value={qty}
            onChange={(e) => handleQuantity(e) }
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
            disabled
        />
    )
}

const QtyReceivedPurchaseCell = ({ params }) => {
    const [qty, setQty] = useState(params.value)

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="qty-received-purchase"
            value={qty}
            onChange={(e) => handleInteger({
                event: e,
                setter: setQty,
                end: 30
            }) }
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                value: qty
            })}
            disabled
        />
    )
}

const VendorCountPurchaseCell = ({ params }) => {
    const [qty, setQty] = useState(params.value)

    return (
        <TextField
            type="text"
            variant='standard'
            className='w-2/3 mb-5 px-0 pt-0'
            name="vendor-count-purchase"
            value={qty}
            onChange={(e) => handleInteger({
                event: e,
                setter: setQty,
                end: 30
            }) }
            onBlur={e => handleZero({
                event: e,
                setter: setQty
            })}
            onFocus={e => deleteZero({
                event: e,
                setter: setQty,
                qty
            })}
        />
    )
}

const UnitPricePurchaseCell = (params) => {
    return (
        <>{params.currencySymbol}{params.params.row.unit_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
    )
}

const TotalPurchaseCell = ({ params, currencySymbol }) => {
    const { value, row } = params;

    const [total, setTotal] = useState(value)

    useEffect(() => {
        setTotal(row.total_cost);
    }, [params])

    return (
        <>{currencySymbol}{total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</>
    )
}

const ActionsPurchase = ({ params, t, salesOrderItems, setSalesOrderItems }) => {
    const deleteItem = async (id) => {
        const filtered = salesOrderItems.filter(i => i.id != id)
        setSalesOrderItems(filtered)
    }

    return (
        <>
            <div className='flex justify-between'>
                <Tooltip disableInteractive title={t('delete')} placement='bottom'>
                    <div style={{ color: 'rgba(0,0,0,.54)' }}>
                        <span style={{ cursor: 'pointer' }} className="flex justify-center items-center hover:rounded-full icons p-2 hover:bg-zinc-200" onClick={() => deleteItem(params.row.id)}><i className="fa-solid fa-trash"></i></span>
                    </div>
                </Tooltip>
            </div>
        </>
    )
}
